export const formName = "directDepositForm";
export const dynamicFormName = "dynamicDirectDepositForm";
export const requiredFields = [
  "routing_number",
  "account_number",
  "birthdate",
  "social_security_number",
  "ach_agree",
];
